import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Calendar, MapPin, Clock, Users, Ticket, ExternalLink } from 'lucide-react';

export const EventDetailsModal = ({ event, open, onClose }) => {
  if (!event) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-gradient-to-b from-black via-orange-950/20 to-black border-orange-500/30 text-white max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-green-400 mb-4">
            {event.name}
          </DialogTitle>
        </DialogHeader>

        {/* Event Image */}
        {event.image && (
          <div className="w-full h-64 mb-6 rounded-lg overflow-hidden">
            <img 
              src={event.image} 
              alt={event.name}
              referrerPolicy="no-referrer"
              
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* Event Details */}
        <div className="space-y-4">
          {/* Date and Time */}
          <div className="flex items-start space-x-3">
            <Calendar className="w-5 h-5 text-orange-400 mt-1 flex-shrink-0" />
            <div>
              <p className="text-gray-400 text-sm">Date & Time</p>
              <p className="text-white font-semibold">
                {event.date}
                {event.time && ` • ${event.time}`}
              </p>
            </div>
          </div>

          {/* Location */}
          <div className="flex items-start space-x-3">
            <MapPin className="w-5 h-5 text-orange-400 mt-1 flex-shrink-0" />
            <div>
              <p className="text-gray-400 text-sm">Venue</p>
              <p className="text-white font-semibold">{event.venue}</p>
              <p className="text-gray-300">{event.city}</p>
            </div>
          </div>

          {/* Description */}
          {event.description && (
            <div className="border-t border-orange-500/20 pt-4">
              <p className="text-gray-400 text-sm mb-2">About This Event</p>
              <p className="text-gray-300 leading-relaxed whitespace-pre-line">
                {event.description}
              </p>
            </div>
          )}

          {/* Lineup */}
          {event.lineup && (
            <div className="border-t border-orange-500/20 pt-4">
              <div className="flex items-center space-x-2 mb-2">
                <Users className="w-5 h-5 text-green-400" />
                <p className="text-gray-400 text-sm">Lineup</p>
              </div>
              <p className="text-gray-300 leading-relaxed whitespace-pre-line">
                {event.lineup}
              </p>
            </div>
          )}

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-orange-500/20">
            <Button
              onClick={() => window.open(event.ticketUrl, '_blank')}
              className="flex-1 bg-gradient-to-r from-orange-500 to-green-500 hover:from-orange-600 hover:to-green-600 text-white font-semibold"
            >
              <Ticket className="w-4 h-4 mr-2" />
              Get Tickets
            </Button>
            
            {event.facebookUrl && (
              <Button
                onClick={() => window.open(event.facebookUrl, '_blank')}
                variant="outline"
                className="flex-1 border-orange-500/50 hover:bg-orange-500/10 text-white"
              >
                <ExternalLink className="w-4 h-4 mr-2" />
                Facebook Event
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};